module.exports = __webpack_public_path__ + "assets/img/Pioneer_Chassard_Chambovet.47d65eb3-ps.jpg";